import { z } from "zod";

export const apiErrorSchema = z.object({
	code: z.string(),
	message: z.string(),
	details: z.record(z.unknown()).optional(),
	field: z.string().optional(),
});
export type ApiError = z.infer<typeof apiErrorSchema>;

export const apiResponseSchema = <T extends z.ZodType>(dataSchema: T) =>
	z.union([
		z.object({ ok: z.literal(true), data: dataSchema }),
		z.object({ ok: z.literal(false), error: apiErrorSchema }),
	]);

export type ApiResponse<T> =
	| { ok: true; data: T }
	| { ok: false; error: ApiError };

export const paginationParamsSchema = z.object({
	page: z.number().int().positive().default(1),
	per_page: z.number().int().positive().max(100).default(20),
	sort_by: z.string().optional(),
	sort_dir: z.enum(["asc", "desc"]).default("desc"),
});
export type PaginationParams = z.infer<typeof paginationParamsSchema>;

export interface PaginatedResponse<T> {
	items: T[];
	total: number;
	page: number;
	per_page: number;
	total_pages: number;
}
